import {
  FETCH_LOAD_COMPANY_BY_ID_REQUEST,
  FETCH_LOAD_COMPANY_BY_ID_SUCCESS,
  FETCH_LOAD_COMPANY_BY_ID_FALUIRE,
} from './loadCompanyByIDTypes'

const initialState = {
  loading: false,
  particularCompanyInformation: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_COMPANY_BY_ID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_COMPANY_BY_ID_SUCCESS : return {
      ...state,
      particularCompanyInformation: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_COMPANY_BY_ID_FALUIRE : return {
      ...state,
      loading: false,
      particularCompanyInformation: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
